import { createFileRoute, useParams } from "@tanstack/react-router";
import { TicketTypeAccessSection } from "./fullAccess";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/ticketTypes/$ticketTypeId/access",
)({
	component: OrgTicketTypeAccessTab,
});

function OrgTicketTypeAccessTab() {
	const { orgId } = useParams({
		from: "/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/ticketTypes/$ticketTypeId/access",
	});

	return (
		<div className="px-5 pb-5">
			<TicketTypeAccessSection organizationId={orgId} />
		</div>
	);
}
